import {
  REDUCER_NAMES_TIME_OF_MOST_RECENT_USER_ACTIVITY as defaultSlice,
} from '../../constants'


export function getTimeOfMostRecentUserActivity(state) {
  return state[defaultSlice]
}
